import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { Container, Spinner } from 'reactstrap';
import { GlobalContext } from '../../context/GlobalContext';
import {Header} from "../header/Header";
import { Eventcalendar, getJson, setOptions, Toast, localeEs } from '@mobiscroll/react';
import {Box, Typography, Chip} from "@mui/material";
import dayjs from "dayjs";
import 'dayjs/locale/es';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Badge} from "react-bootstrap";

const { getISOWeek } = require('date-fns');



export const Horarios = () => {

  dayjs.locale('es')

  //GET GLOBAL CONTEXT
  const context = useContext(GlobalContext);
  const { Horarios, darkTheme, isMobile, setIsMobile } = context;

  setOptions({
    locale: localeEs,
    theme: 'material',
    themeVariant: darkTheme ? 'dark' : 'light'
  });

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: darkTheme ? 'black' : 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };


  //State declarations
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [modalData, setmodalData] = useState([]);

  useEffect(() => {
    if (Horarios) {
      setData(Horarios.data);
      setIsMobile(Horarios.isMobile);
      setIsLoading(false);
      console.log(Horarios);
    }
  }, [Horarios]);

  const [myEvents, setEvents] = useState([]);
  const [isToastOpen, setToastOpen] = useState(false);
  const [toastText, setToastText] = useState();
  const [open, setOpen] = React.useState(false);
  const handleOpen = useCallback((args) => {
    console.log(args.event);
    setmodalData(args.event);
    setOpen(true);
  }, []);
  const handleClose = () => setOpen(false);

  const myView = useMemo(
    () => ({
      schedule: {
        type: 'week' ,
        startTime: '07:00',
        endTime: '22:00',
        startDay: 1,
        endDay: 6,
      },
    }),
    [],
  );



  const handleCloseToast = useCallback(() => {
    setToastOpen(false);
  }, []);

  const handleEventClick = useCallback(() => {
    setToastOpen(true);
  }, []);

  useEffect(() => {
    getJson(
      '/calificaciones/gethorarios',
      (events) => {
        setEvents(events);
        setIsLoading(false);
        console.log(context.Claims);
      },
      'json',
    );
  }, []);

  const handlePageLoading = useCallback((args) => {
    console.log();

    handleEventClick();
    getJson(
      `/calificaciones/gethorarios?week=${getISOWeek(args.firstDay)}`,
      (data) => {

        setEvents(data);
        setIsLoading(false);
        handleCloseToast();
      },
      'json',
    );
  }, []);



  return (
    <>
      <Modal show={open} onHide={handleClose}  data-bs-theme={darkTheme ? "dark" : "light"} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalData.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row xs="auto" className='mt-5'>
              <Col><Badge bg="secondary">{modalData.eventAttendanceMode}</Badge> </Col>
              <Col><Badge bg="secondary">{modalData.inLanguage}</Badge></Col>
            </Row>
            <br/>
            {!modalData.allDay &&
              <Row xs="auto" className='mt-5'>
                <Col><img src="/Images/iconos/Time.svg"/> </Col>
                <Col>{` ${dayjs(modalData.start).format('dddd h:mm A')} - ${dayjs(modalData.end).format('dddd h:mm A')}`}</Col>
              </Row>
            }
            {modalData.place?.location !== " " &&
              <Row xs="auto" className='mt-5'>
                <Col><img src="/Images/iconos/Place.svg"/> </Col>
                <Col>{` ${modalData.place?.location}`}</Col>
              </Row>
            }
            <Row xs="auto" className='mt-5'>
              <Col><img src="/Images/iconos/Assignment.svg"/></Col>
              <Col>{` ${modalData.course?.instructor.personName.givenName}`}</Col>
            </Row>

          </Container>
        </Modal.Body>
      </Modal>
      <Header title={'Mi Horario'} />
      {
        (isLoading) ?
          <Container className="spinner-container">
            <Spinner style={{ width: '3rem', height: '3rem' }} color="primary" />
          </Container>
          :
          <Container className={(darkTheme) ? "home__bg-white bg-dark-primary" : "home__bg-white"}>

            <Eventcalendar
              clickToCreate={false}
              dragToCreate={false}
              dragToMove={false}
              dragToResize={false}
              eventDelete={false}
              data={myEvents}
              view={myView}
              onEventClick={handleOpen}
            />
            <Toast message="actualizando" isOpen={isToastOpen} />

          </Container>
      }
    </>
  );
}
